"use strict";
import decode_auth_token from '../decodeAuthToken';

const isAuth = () => {
    try {
        const user = decode_auth_token();
        if (user && process.env.ANONYMOUS_ID && parseInt(user.id) !== parseInt(process.env.ANONYMOUS_ID)) {
            return true;
        }
        return false;
    } catch (err) {
        console.log('RMS', err);
        return false;
    }
}

export default isAuth;
